import { Game } from "../../Game";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class CatContainer extends Phaser.GameObjects.Container {

    private candies: Phaser.GameObjects.Image [];
    private a: number;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
       
        if (Game.currentInstance.device.os.desktop) {

            this.setScale(.8);

            this.y = GameConstants.GAME_HEIGHT / 2 + 110;

        } else {

            const aspectRatio = window.innerHeight / window.innerWidth;

            if (aspectRatio > 1.6) {
                this.y = GameConstants.GAME_HEIGHT / 2 + 120 * GameVars.scaleY;
                this.scaleY = GameVars.scaleY;
            } else {
                this.y = GameConstants.GAME_HEIGHT / 2 + 120 * GameVars.scaleY;
                this.setScale(.8, .8 * GameVars.scaleY);
            }
        }

        this.a = 0;

        const splashGlare = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_7", "splash_glare");
        splashGlare.blendMode = Phaser.BlendModes.SCREEN;
        this.add(splashGlare);

        this.scene.tweens.add({
            targets: splashGlare,
            scaleX: 1.35,
            scaleY: 1.35,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 2500,
            repeat: -1,
            yoyo: true
        });

        this.candies = [];

        let orbIndex = 1;

        for (let i = 0; i < 11; i ++) {

            const candy = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "orb-" + orbIndex);
            candy.setScale(1.3);
            this.add(candy);

            orbIndex = orbIndex < 6 ? orbIndex + 1 : 1;

            this.candies.push(candy);
        }

        const pillow = new Phaser.GameObjects.Image(this.scene, 0, 95, "texture_atlas_3", "neko_pillow");
        this.add(pillow);

        const catContainer = new Phaser.GameObjects.Container(this.scene);
        catContainer.y = 235;
        catContainer.scaleX = .985;
        catContainer.scaleY = 1.015;
        this.add(catContainer);

        const cat = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "neko");
        cat.setOrigin(.5, .85);
        catContainer.add(cat);

        const arm = new Phaser.GameObjects.Image(this.scene, 120, -170, "texture_atlas_1", "neko_arm");
        catContainer.add(arm);

        this.scene.tweens.add({
            targets: arm,
            y: -190,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 1250,
            repeat: -1,
            yoyo: true
        });

        const patch = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "neko_patch");
        patch.setOrigin(.5, .85);
        catContainer.add(patch);

        this.scene.tweens.add({
            targets: catContainer,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 1250,
            repeat: -1,
            yoyo: true
        });
    }

    public update(): void {

        let a = this.a;
        
        for (let i = 0; i < this.candies.length; i ++) {

            const x = 240 * Math.cos(a);
            const y = 210 * Math.sin(a);

            this.candies[i].x = x;
            this.candies[i].y = y;

            a += 360 / 11 * Math.PI / 180;
        }

        this.a += .0125;
    }
}
